import Vue from 'vue'

const EventBus = new Vue()

export const Events = {
  B_MENU_ITEM_CLICKED: 'b-menu-item-clicked',
  B_MENU_BACK_CLICKED: 'b-menu-back-clicked',
  B_MENU_BREADCRUMB_ITEM_CLICKED: 'b-menu-breadcrumb-item-clicked',
  B_MENU_ITEM_DELETE: 'b-menu-item-delete',
  B_MENU_ITEM_EDIT: 'b-menu-item-edit',
  B_MENU_ITEM_SAVE: 'b-menu-item-save',
  B_MENU_ITEM_DRAG_START: 'b-menu-item-drag-start',
  B_MENU_ITEM_DRAG_END: 'b-menu-item-drag-end',
  B_MENU_ITEM_ORDER_CHANGED: 'b-menu-item-order-changed',
  B_MENU_ITEM_PARENT_CHANGED: 'b-menu-item-parent-changed',
  B_MENU_ACTIVE_VIEW_CHANGED: 'b-menu-active-view-changed'
}

export default EventBus
